export const inputWithAction = require('b_').with('input-with-action');
